import React from 'react';
import {useSelector} from "react-redux";
import {assetsBaseUrl} from "../../services/calculationsApi";
import ReactTooltip from "react-tooltip";
import {useMediaQuery} from "@react-hook/media-query";
import {CALCULATOR_TYPES, getCalculatorType, mainMediaMobile, numberToCurrency} from "../../services/helpers";
import {FormattedMessage, useIntl} from "react-intl";

const OverviewModal = ({toggleOverview, componentRef}) => {
    const intl = useIntl();
    const mediaMatches = useMediaQuery(mainMediaMobile);
    const {
        RentevastePeriode,
        ApplicantYearlyIncome,
        PartnerYearlyIncome,
        IsNieuwbouw,
        OwnResources,
        bankData,
        Woning,
        Interest,
        HasLoans,
        PrivateLeaseAmount,
        Loans,
        Alimony,
        StudentDebtMonthlyPayment,
        response: {
            maxMortgageAmount,
            grossMonthlyCost,
            grossMonthlyCostHouse,
            netMonthlyCost,
            netMonthlyCostHouse,
            riskClass,
            isNhg
        }
    } = useSelector(state => state.calculator);

    const mortgageTypeLabel = (getCalculatorType() !== CALCULATOR_TYPES.watWordenMijnMaandLasten) ?
    intl.formatMessage({id: 'overviewModal.house.askingPrice', defaultMessage: 'Vraagprijs woning'}) :
    intl.formatMessage({id: 'overviewModal.house.desiredMortgage', defaultMessage: 'Gewenste hypotheek'});
    return (
        <div className="ct-step__modal-wrapper">
            <div className={`ct-step__overview-modal-wrapper ${mediaMatches && 'ct-step__overview-modal-wrapper--mobile' }`}>

                <div className="close-overview" onClick={toggleOverview}>
                    <img src={`${assetsBaseUrl}/assets/svg/close.svg`} alt=""/>
                </div>

                <div className="ct-step__overview-modal" ref={componentRef}>
                    <div ref={componentRef}>
                        <div className="ct-step__overview-modal-title">
                          <FormattedMessage id={'overviewModal.house'} defaultMessage={'Jouw berekening'}/>
                        </div>

                        {Woning > 0 &&
                        <div>
                            <div className="ct-step__overview-modal-subtitle">
                              <FormattedMessage id={'overviewModal.house.subtitle'} defaultMessage={'Woning'}/>
                            </div>

                            <div
                            className="ct-step__overview-modal-field ct-step__overview-modal-field-gray">
                              <div>
                                { mortgageTypeLabel }
                              </div>

                              <div>
                                {numberToCurrency(Woning ? Woning : 0)}
                              </div>
                            </div>

                            <div className="ct-step__overview-modal-field ct-step__overview-modal-field-gray">
                              <div>
                                <FormattedMessage id={'overviewModal.house.grossMonthlyCost'} defaultMessage={'Bruto maandlasten'}/>
                              </div>

                              <div>
                                {numberToCurrency(Woning > 0 ? grossMonthlyCostHouse : 0)}
                              </div>
                            </div>


                            <div className="ct-step__overview-modal-field ct-step__overview-modal-field-gray">
                              <div>
                                <FormattedMessage id={'overviewModal.house.netMonthlyCost'} defaultMessage={'Netto maandlasten'}/>
                              </div>

                              <div>
                                {numberToCurrency(Woning > 0 ? netMonthlyCostHouse : 0)}
                              </div>
                            </div>
                        </div>
                        }
                        <div className="ct-step__overview-modal-subtitle">
                          <FormattedMessage id={'overviewModal.maxMortgage'} defaultMessage={'Maximale hypotheek'}/>
                        </div>


                        <div className="ct-step__overview-modal-field ct-step__overview-modal-field-gray">
                            <div>
                              <FormattedMessage id={'overviewModal.maxMortgage.applicantYearlyIncome'} defaultMessage={'Bruto jaarinkomen'}/>
                            </div>

                            <div>
                                {numberToCurrency(ApplicantYearlyIncome ? ApplicantYearlyIncome : 0)}
                            </div>
                        </div>

                        {PartnerYearlyIncome > 0 &&
                        <div className="ct-step__overview-modal-field ct-step__overview-modal-field-gray">
                            <div>
                              <FormattedMessage id={'overviewModal.maxMortgage.partnerYearlyIncome'} defaultMessage={'Bruto partner jaarinkomen'}/>
                            </div>

                            <div>
                                {numberToCurrency(PartnerYearlyIncome ? PartnerYearlyIncome : 0)}
                            </div>
                        </div>
                        }
                        {HasLoans &&
                        <div className="ct-step__overview-modal-field ct-step__overview-modal-field-gray">
                            <div>
                              <FormattedMessage id={'overviewModal.maxMortgage.loans'} defaultMessage={'Kredieten en leningen'}/>
                            </div>
                            {HasLoans &&
                                <div>
                                    {numberToCurrency((+Loans +StudentDebtMonthlyPayment +Alimony +PrivateLeaseAmount))}
                                </div>
                            }
                            {!HasLoans &&
                                <div>
                                  <FormattedMessage id={'overviewModal.maxMortgage.loans.no'} defaultMessage={'Nee'}/>
                                </div>
                            }
                        </div>
                        }

                        <div
                            className="ct-step__overview-modal-subtitle ct-step__overview-modal-subtitle-with-background ct-step__overview-modal-field ">
                            <div>
                              <FormattedMessage id={'overviewModal.maxMortgage.maxMortgage'} defaultMessage={'Maximale hypotheek'}/>
                            </div>

                            <div>
                                {numberToCurrency(maxMortgageAmount ? maxMortgageAmount : 0)}
                            </div>
                        </div>

                        <div className="ct-step__overview-modal-field">
                            <div>
                              <FormattedMessage id={'overviewModal.maxMortgage.grossMonthlyCost'} defaultMessage={'Bruto maandlasten'}/>
                            </div>

                            <div>
                                {numberToCurrency(grossMonthlyCost > 0 ? grossMonthlyCost : 0)}
                            </div>
                        </div>


                        <div className="ct-step__overview-modal-field">
                            <div>
                              <FormattedMessage id={'overviewModal.maxMortgage.netMonthlyCost'} defaultMessage={'Netto maandlasten'}/>
                            </div>

                            <div>
                                {numberToCurrency(netMonthlyCost > 0 ? netMonthlyCost : 0)}
                            </div>
                        </div>
                        <div className="ct-step__overview-modal-text">
                            {parseInt(IsNieuwbouw) !== 2 &&
                                <span>
                                  <FormattedMessage id={'overviewModal.maxMortgage.extraCosts'} defaultMessage={'Bij het kopen van een woning komen extra kosten kijken die de koper zelf dient te financieren, ook wel kosten koper genoemd. Dit zijn in ieder geval de overdrachtsbelasting, notariskosten, taxatiekosten. Daarnaast kan er sprake zijn van o.a. advies- en bemiddelingskosten en eventueel kosten voor NHG.'}/>
                                </span>
                            }
                            {parseInt(IsNieuwbouw) === 2 &&
                                <span>
                                  <FormattedMessage id={'overviewModal.maxMortgage.extraCostsNew'} defaultMessage={'Bij het kopen van een nieuwbouwwoning komen extra kosten kijken die de koper zelf dient te financieren, ook wel kosten koper genoemd. Dit zijn in ieder geval de notariskosten voor de hypotheekakte, advies- en bemiddelingskosten en eventueel kosten voor NHG.'}/>
                                </span>
                            }
                        </div>

                        { parseInt(OwnResources) > 0 &&
                        <div className="ct-step__overview-modal-own-money">
                          <div className="ct-step__overview-modal-subtitle">
                            <FormattedMessage id={'overviewModal.ownMoney'} defaultMessage={'Eigen inleg'}/>
                          </div>

                          <div className="ct-step__overview-modal-field ct-step__overview-modal-field-gray">
                              <div>
                                  <span>
                                    <FormattedMessage id={'overviewModal.ownMoney.ownMoney'} defaultMessage={'Inleg eigen geld'}/>
                                  </span>
                                  <img className="ct-step__tool-tip"
                                        data-tip={intl.formatMessage({id: 'overviewModal.ownMoney.ownMoney.toolTip', defaultMessage: `Dit is het bedrag dat je hebt aangegeven in te willen brengen bij de aankoop van je nieuwe woning`})} src={`${assetsBaseUrl}/assets/svg/info.svg`} alt=""/>
                                  <ReactTooltip
                                  place={"right"}
                                  effect={"solid"}
                                  />
                              </div>

                              <div>
                                  {numberToCurrency(OwnResources ? OwnResources : 0)}
                              </div>
                          </div>
                        </div>
                        }

                        <div className="ct-step__overview-modal-deze-wrapper">

                            <div className="ct-step__overview-modal-deze">
                              <FormattedMessage id={'overviewModal.basedOn'} defaultMessage={'Deze berekening is gebaseerd op:'}/>
                            </div>

                            <div className="ct-step__overview-modal-field">
                                <div>
                                  <FormattedMessage id={'overviewModal.basedOn.mortgageType'} defaultMessage={'Hypotheekvorm'}/>
                                </div>

                                <div>
                                    {bankData.mainBank.hypotheekVorm === 'Annuïteitenhypotheek' ? 'Annuïteiten' : 'Lineair'}
                                </div>
                            </div>

                            <div className="ct-step__overview-modal-field">
                                <div>
                                  <FormattedMessage id={'overviewModal.basedOn.duration'} defaultMessage={'Looptijd'}/>
                                </div>

                                <div>
                                  <FormattedMessage id={'overviewModal.basedOn.duration.years'} defaultMessage={'30 jaar'}/>
                                </div>
                            </div>

                            <div className="ct-step__overview-modal-field">
                                <div>
                                  <FormattedMessage id={'overviewModal.basedOn.interest'} defaultMessage={'Rente'}/>
                                </div>

                                <div>
                                    {Interest ? Interest : 0} %
                                </div>
                            </div>

                            <div className="ct-step__overview-modal-field">
                                <div>
                                  <FormattedMessage id={'overviewModal.basedOn.interestPeriod'} defaultMessage={'Rentevaste periode'}/>
                                </div>

                                <div>
                                  <FormattedMessage id={'overviewModal.basedOn.interestYears'} defaultMessage={'{rentevastePeriode} jaar{plural} rentevast'} values={
                                      {rentevastePeriode: RentevastePeriode, plural: RentevastePeriode > 1 && intl.locale === 'en' ? 's' : ''}
                                  }/>
                                </div>
                            </div>
                            { riskClass > 0 &&
                                <div className="ct-step__overview-modal-field">
                                    <div>
                                      <FormattedMessage id={'overviewModal.basedOn.riskClass'} defaultMessage={'Risicoklasse'}/>
                                    </div>

                                    <div>
                                        {riskClass} %
                                    </div>
                                </div>
                            }
                            <div className="ct-step__overview-modal-field">
                                <div>
                                  <FormattedMessage id={'overviewModal.basedOn.nhg'} defaultMessage={'Nationale Hypotheek Garantie (NHG)'}/>
                                </div>

                                <div>
                                  <FormattedMessage id={'overviewModal.basedOn.nhg.yes'} defaultMessage={'{answer}'} values={
                                      {answer: isNhg ? 'Ja' : 'Nee'}
                                  }/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default OverviewModal;
